<button type="button" mat-button class="next" value="nextStep">შემდეგი <i
  class="fas fa-chevron-right"></i></button>
